/**
 * 401 응답 시 토큰 갱신(refresh) 시도 여부 판정.
 *
 * 2026-10-12 라이브 장애: 시설관리자 로그인 페이지에서 잘못된 비밀번호로 로그인하면
 * `/auth/login` 401 → (localStorage 의 유효한 refreshToken 으로) refresh 200 →
 * 원 요청(login) 재시도 401 → refresh 200 … 이 무한 반복됐다 (IP 1개, 약 60회/초).
 * 원인은 두 가지였다.
 *   1) 자격 증명 엔드포인트(login 등)의 401 은 "토큰 만료"가 아니라 "자격 증명 오류"인데도 refresh 를 시도
 *   2) 재시도한 요청이 다시 401 이어도 또 refresh 를 시도 (재시도 표식 없음)
 */

/** 401 이 토큰 만료가 아니라 자격 증명/토큰 자체 오류를 뜻하는 인증 엔드포인트 */
const CREDENTIAL_ENDPOINT_PATTERNS: RegExp[] = [
  /\/auth\/login(?:[/?#]|$)/,
  /\/auth\/signup(?:[/?#]|$)/,
  /\/auth\/oauth\//,
  /\/auth\/token\/refresh(?:[/?#]|$)/,
]

export function isCredentialEndpoint(url: string | undefined): boolean {
  if (!url) return false
  return CREDENTIAL_ENDPOINT_PATTERNS.some((pattern) => pattern.test(url))
}

/** 재시도 표식이 붙을 수 있는 요청 설정 (axios InternalAxiosRequestConfig 의 부분 집합) */
export interface RetryableRequestConfig {
  url?: string
  _retry?: boolean
}

/**
 * 401 응답을 받은 요청에 대해 refresh 후 재시도할지 판정한다.
 * - 자격 증명 엔드포인트(login/signup/oauth/refresh)는 갱신하지 않는다
 * - 이미 한 번 갱신 후 재시도한 요청은 다시 갱신하지 않는다 (요청당 최대 1회)
 */
export function shouldAttemptTokenRefresh(
  status: number,
  config: RetryableRequestConfig | undefined
): boolean {
  if (status !== 401 || !config) return false
  if (config._retry) return false
  if (isCredentialEndpoint(config.url)) return false
  return true
}
